import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import CellPriceWithCurrency from "../../../../сell/CellPriceWithCurrency";
import {Link, useNavigate} from "react-router-dom";
import {Button, Tooltip} from "@mui/material";
import {Edit, Unarchive} from "@mui/icons-material";
import CellCheckboxAMPUTFixPrice from "../arrival/CellCheckboxAMPUTFixPrice";
import FilterUtil from "../../../../../../utils/common/FilterUtil";
import CellCheckbox from "../../../../сheckbox/CellCheckbox";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import ButtonCreate from "../../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import ButtonBack from "../../../../button/ButtonBack";

const SupplierMaterialTable = ({
                                   data,
                                   setData,
                                   handleAddSupplierMaterial,
                                   handleUpdateSupplierMaterial,
                                   isArchive,
                                   id,
                                   materialId,
                                   baseUnit,
                                   typeMaterial,
                                   allPrice,
                                   urlArchive,
                                   addArchive,
                                   isAll,
                                   currencyMap,
                                   tableOptions,
                                   tableOptionsHandle,
                                   handleModalAlert,
                                   isAdmin,
                                   readOnly,
                                   modal,
                                   selectedString,
                                   setSelectedString,
                               }) => {

        const navigate = useNavigate();
        const redirectArchive = () => {
            navigate(urlArchive + '/' + id + '/' + baseUnit + '/' + typeMaterial + '/' + materialId);
        };

        const redirectMaterial = () => {
            navigate(isAll ? '/all-materials/' + materialId + '/' + baseUnit + '/' + typeMaterial : '/organization/materials/' + id + '/' + baseUnit + '/' + typeMaterial + '/' + materialId);
        };

        const sendToArchive = useCallback(
            (row) => {
                addArchive(row.id)
                    .then(function () {
                        setData(prev => prev.filter(el => el.id !== row.id));
                    })
                    .catch(function (error) {
                        handleModalAlert(error);
                    })
            },
            [data],
        );

        const columns = useMemo(() => {
            const baseColumns = [
                {
                    header: 'Поставщик',
                    accessorFn: (row) => row.supplier?.name,
                    minSize: 150,
                    Cell: ({cell, row}) => (
                        <li key={cell.getValue()}>
                            {modal ? cell.getValue() : <Link
                                to={'/organization/suppliers/' + data[row.index].supplier?.id}>{cell.getValue()}</Link>}
                        </li>
                    ),
                },
                {
                    header: 'Артикул поставщика',
                    accessorKey: 'article',
                    minSize: 150,
                },
                {
                    header: 'Найменование поставщика',
                    accessorKey: 'materialNameSupplier',
                    minSize: 250,
                },
                {
                    id: 'basePrice',
                    header: 'Баз. цена',
                    accessorFn: (row) => row.basePrice?.price,
                    size: 8,
                    Cell: ({row}) => {
                        const basePrice = row.original?.basePrice || null;
                        return basePrice === null ? '' : (
                            <CellCheckboxAMPUTFixPrice
                                price={basePrice}
                                disabled={true}
                                fixPrice={row.original?.fixPrice}
                                currencyMap={currencyMap}
                            />
                        );
                    },
                    minSize: 8,
                    maxSize: 8,
                },
                {
                    id: 'priceGroup',
                    header: 'Ценовая группа',
                    accessorKey: 'priceGroup'
                },
                {
                    id: 'basePrice.dateTime',
                    header: 'Дата',
                    accessorFn: (row) => row.basePrice?.dateTime,
                    minSize: 10,
                    maxSize: 10,
                    Cell: ({cell}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? '' : DateTimeUtil.dateTimeToString(value);
                    },
                    filterFn: (row, id, filterValue) => {
                        const startDate = filterValue?.startDate;
                        const endDate = filterValue?.endDate;
                        if (startDate && endDate) {
                            return (
                                DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                                DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                            );
                        }
                        return true;
                    },
                    Filter: ({column}) => <DateRangeFilter column={column}/>,
                },
            ];

            if (modal && typeMaterial === "SLAB") {
                baseColumns.splice(2, 0, {
                    id: 'length', header: 'Ширина', accessorKey: 'length', minSize: 15, maxSize: 15,
                })
                baseColumns.splice(2, 0, {
                        id: 'width', header: 'Высота', accessorKey: 'width', minSize: 15, maxSize: 15,
                    }
                )
            }

            if (isArchive && !isAdmin) {
                baseColumns.splice(0, 0, {
                    id: 'current',
                    header: 'Текущий',
                    accessorKey: 'current',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <CellCheckbox
                        cell={cell}
                        disabled={true}
                    />,
                });
            }

            if ((allPrice && !isAdmin) || modal) {
                baseColumns.splice(7, 0, {
                    id: 'lastRealPrice',
                    header: 'Посл. реальная цена',
                    accessorFn: (row) => row.lastRealPrice?.price,
                    size: 8,
                    Cell: ({row}) => {
                        const lastRealPrice = row.original.lastRealPrice
                        return lastRealPrice && (
                            <span>{lastRealPrice?.price?.toFixed(3)} {currencyMap.get(lastRealPrice.currencyId).curAbbreviation}</span>)
                    },
                    minSize: 10,
                    maxSize: 10,
                });
            }

            if ((allPrice && !isAdmin) || modal) {
                baseColumns.splice(8, 0, {
                    id: 'averageRealPrice',
                    header: 'Ср. реальная цена',
                    accessorFn: (row) => row.averageRealPrice?.price,
                    size: 8,
                    Cell: ({row}) => {
                        const averageRealPrice = row.original.averageRealPrice
                        return averageRealPrice && (
                            <span>{averageRealPrice?.price?.toFixed(3)} {currencyMap.get(averageRealPrice.currencyId).curAbbreviation}</span>)
                    },
                    minSize: 10,
                    maxSize: 10,
                });
            }

            if ((allPrice && !isAdmin) || modal) {
                baseColumns.splice(9, 0, {
                    id: 'maxRealPrice',
                    header: 'Макс. реальная цена',
                    accessorFn: (row) => row.maxRealPrice?.price,
                    size: 8,
                    Cell: ({row}) => {
                        const maxRealPrice = row.original.maxRealPrice
                        return maxRealPrice && (
                            <span>{maxRealPrice?.price?.toFixed(3)} {currencyMap.get(maxRealPrice.currencyId).curAbbreviation}</span>)
                    },
                    minSize: 10,
                    maxSize: 10,
                });
            }

            return baseColumns;

        }, [data, isArchive]);

        const menuItem = [
            {type: "edit", text: "Редактировать", handler: handleUpdateSupplierMaterial},
            {type: "archive", text: "В архив", handler: sendToArchive}
        ]

        return (
            <div>
                {!modal && <Box
                    sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px", gap: "10px"}}
                >
                    {!isArchive && !readOnly && <ButtonCreate
                        text={typeMaterial === 'SLAB' ? "Добавить цену одного листа" : "Добавить цену поставщика"}
                        width={270}
                        onClick={handleAddSupplierMaterial}
                    />}

                    {!isArchive && <ButtonCreate
                        text={"Архив цен"}
                        width={100}
                        icon={false}
                        onClick={redirectArchive}
                    />}
                    {isArchive && <ButtonBack
                        text={"Вернуться к материалу"}
                        width={230}
                        onClick={redirectMaterial}
                    />}
                </Box>}
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "&:first-of-type": !isArchive && !readOnly && !modal && {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },
                            "& li": {
                                listStyleType: "none",
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }
                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            onClick: () => modal && setSelectedString(row.original),
                            sx: () => ({
                                height: '36px',
                                cursor: modal && "pointer",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                    },
                                },
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : "white",
                                "&:hover": {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                            })
                        })
                    }}

                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    columns={columns}
                    data={data || []}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        pagination: {pageIndex: 0, pageSize: 100},
                    }}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}

                    state={{showGlobalFilter: true, pagination: tableOptions,}}
                    rowCount={tableOptions.totalElements}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    localization={MRT_Localization_RU}
                    enableRowActions={!isArchive && !readOnly && !modal}
                    enableToolbarInternalActions={false}
                    getRowId={(originalRow) => originalRow.id}
                />
            </div>
        );
    }
;

export default SupplierMaterialTable;